<template>
    <div
        v-if="result?.listings?.length > 0"
        class="md-house layout1 mg-bg"
        :style="{ ...spaceStyle, ...colorStyle }"
    >
        <div class="f-col">
            <site-title :title="title"></site-title>
            <site-sub-title class="desc" :title="desc"></site-sub-title>
            <Grid></Grid>
            <site-button
                v-if="moreShow && moreText"
                type="plain"
                :html="moreText"
                class="button-more"
                :href="moreLink"
                :aria-label="moreLinkPurpose"
                rel="noopener noreferrer"
            ></site-button>
        </div>
    </div>
    <div v-else-if="waiting" class="waiting"></div>
</template>

<script>
import Core from '../index';
import Grid from './grid.vue';

export default {
    mixins: [Core],
    components: { Grid }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
.md-house.layout1 {
    .site-subtitle {
        margin-top: 8px;
        padding-bottom: 4px;
        @include media-600 {
            margin-top: 8px;
            padding-bottom: 1px;
        }
    }
    .house-grid {
        margin-top: 32px;
        @include media-600 {
            margin-top: 15px;
        }
    }
    .button-more {
        display: flex;
        font-size: 16px;
        width: 200px;
        height: 50px;
        margin: 0 auto;
    }
}
</style>
